import { Stack } from "@altimateai/lego";
import { useTenantUsers } from "../../services/common";
import { TableDetailResponse } from "./types";
import { HeaderSection } from "./components/HeaderSection";
import { ColumnSection } from "./components/ColumnSection";
import { PurposeSection } from "./components/PurposeSection";

interface SchemaProps {
  table: TableDetailResponse;
}

const Schema = ({ table }: SchemaProps) => {
  const { users } = useTenantUsers();

  return (
    <Stack direction="column" className="al-h-full gap-md" aria-label="Schema tab content">
      <HeaderSection table={table} />
      <PurposeSection
        tableId={table.id}
        purpose={table.description}
        users={users}
        lastModifiedBy={table.last_modified_by}
      />
      <div className="mb-1"></div>
      <ColumnSection
        columns={table.columns || []}
        users={users}
        scope={table.scope}
        datastoreType={table.datasource_type}
      />
    </Stack>
  );
};

export { Schema };
